import { service } from '../../helpers/http'

export default {
  actions: {
    ActionAmbienceBalanceRulesIndex: ({ commit }, payload) => {
      const p = { ...(payload || {}) }

      // TablesDataTables envia `search`; backend espera `q`
      if (p.search != null && String(p.search).trim() !== '') {
        p.q = p.search
      }
      delete p.search

      // Endpoint nao usa ordenacao do componente
      delete p.column_order
      delete p.direction

      return service({
        module: 'ambienceBalanceRules',
        action: 'index',
        payload: p,
      })
    },

    ActionAmbienceBalanceRulesDuplicate: ({ commit }, payload) =>
      service({
        module: 'ambienceBalanceRules',
        action: 'duplicate',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceBalanceRulesToggle: ({ commit }, payload) => {
      const body = {}
      if (Object.prototype.hasOwnProperty.call(payload || {}, 'active')) {
        body.active = payload.active
      }

      return service({
        module: 'ambienceBalanceRules',
        action: 'toggle',
        params: { id: payload.id },
        payload: body,
      })
    },

    ActionAmbienceBalanceRulesDestroy: ({ commit }, payload) =>
      service({
        module: 'ambienceBalanceRules',
        action: 'destroy',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceBalanceRulesShow: ({ commit }, payload) =>
      service({
        module: 'ambienceBalanceRules',
        action: 'show',
        params: { id: payload.id },
        payload: {},
      }),

    ActionAmbienceBalanceRulesStore: ({ commit }, payload) =>
      service({
        module: 'ambienceBalanceRules',
        action: 'store',
        payload,
      }),

    ActionAmbienceBalanceRulesUpdate: ({ commit }, payload) =>
      service({
        module: 'ambienceBalanceRules',
        action: 'update',
        params: { id: payload.id },
        payload,
      }),
  },
  namespaced: true,
}
